import { Capacitor } from "@capacitor/core";

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result).split(",")[1] ?? "");
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function downloadToCache(imageUrl, fileName) {
  const { Filesystem, Directory } = await import("@capacitor/filesystem");
  const res = await fetch(imageUrl);
  const blob = await res.blob();
  const base64 = await blobToBase64(blob);
  const saved = await Filesystem.writeFile({ path: fileName, data: base64, directory: Directory.Cache });
  return saved.uri;
}

/**
 * Comparte texto/enlace (y opcionalmente una imagen) con la hoja nativa de Android/iOS.
 * En navegador usa la Web Share API si existe, y si no copia el enlace al portapapeles.
 * Devuelve "shared", "copied" o "cancelled".
 */
export async function shareContent({ title, text, url, imageUrl, fileName = "qkiere.jpg" }) {
  if (Capacitor.isNativePlatform()) {
    const { Share } = await import("@capacitor/share");
    let filePath;
    if (imageUrl) {
      try {
        filePath = await downloadToCache(imageUrl, fileName);
      } catch {
        // si falla la descarga de la imagen, se comparte solo el texto/enlace
      }
    }
    try {
      await Share.share({ title, text, url, ...(filePath ? { files: [filePath] } : {}) });
      return "shared";
    } catch (err) {
      if (String(err?.message || "").toLowerCase().includes("cancel")) return "cancelled";
      throw err;
    }
  }

  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (err) {
      if (err?.name === "AbortError") return "cancelled";
      throw err;
    }
  }

  await navigator.clipboard.writeText(url);
  return "copied";
}
